import { getAuthHeaders } from '../../../actions/authActions';
import tempMeeApi from '../../../apis/tempMee';

export const getPromotions = async () => {
  const headers = await getAuthHeaders();
  const response = await tempMeeApi.get('/payment/admin/promotion-campaigns', {
    headers,
  });

  return response.data;
};
